import React from "react";
import { Link } from "react-router-dom";
import { INVICTAX_URL } from "@/components/PoweredByInvictaX";

export default function Impressum() {
  return (
    <div className="min-h-screen bg-slate-50">
      <header className="bg-white border-b border-slate-200 px-6 py-4">
        <div className="max-w-4xl mx-auto flex items-center justify-between">
          <Link to="/" className="text-lg font-semibold text-slate-900">
            Buchhaltung CH
          </Link>
          <nav className="text-sm space-x-4 text-slate-600">
            <Link to="/plattformen" className="hover:text-slate-900">Unsere Plattformen</Link>
            <Link to="/privacy" className="hover:text-slate-900">Datenschutz</Link>
            <Link to="/terms" className="hover:text-slate-900">AGB</Link>
            <Link to="/login" className="text-indigo-600 hover:text-indigo-700">Anmelden</Link>
          </nav>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-6 py-12" data-testid="impressum-page">
        <h1 className="text-3xl font-bold text-slate-900 mb-8">Impressum</h1>

        <section className="space-y-6 text-slate-700 leading-relaxed">
          <div>
            <h2 className="text-xl font-semibold text-slate-900 mb-3">Unternehmensangaben</h2>
            <p>
              <strong>InvictaX Group GmbH</strong>
              <br />
              Bahnhofstrasse 75
              <br />
              8620 Wetzikon (ZH), Schweiz
              <br />
              Web:{" "}
              <a href={INVICTAX_URL} target="_blank" rel="noopener noreferrer" className="text-indigo-600">
                {INVICTAX_URL.replace("https://", "")}
              </a>
              <br />
              E-Mail:{" "}
              <a href="mailto:info@ch-buchhaltung.ch" className="text-indigo-600">
                info@ch-buchhaltung.ch
              </a>
            </p>
            <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-1.5 text-sm">
              <div><span className="text-slate-500">Rechtsform:</span> Gesellschaft mit beschränkter Haftung (GmbH)</div>
              <div><span className="text-slate-500">Rechtssitz:</span> 8620 Wetzikon (ZH), Schweiz</div>
              <div><span className="text-slate-500">Eintrag ins Handelsregister:</span> 19.06.2026</div>
              <div><span className="text-slate-500">Handelsregisteramt:</span> Kanton Zürich</div>
              <div><span className="text-slate-500">Handelsregister-Nummer:</span> CH-020.4.092.608-3</div>
              <div><span className="text-slate-500">UID:</span> CHE-440.580.273</div>
              <div><span className="text-slate-500">MWST-Nummer:</span> CHE-440.580.273 MWST</div>
            </div>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-slate-900 mb-3">Hinweis</h2>
            <p data-testid="impressum-invictax-notice">
              Diese Website sowie die zugrunde liegende Softwareplattform werden von der{" "}
              <strong>InvictaX Group GmbH</strong> entwickelt, betrieben und lizenziert. Die
              InvictaX Group GmbH ist verantwortlich für die technische Infrastruktur,
              Softwareentwicklung, den Betrieb, die Wartung sowie die kontinuierliche
              Weiterentwicklung der Plattform.
            </p>
            <p className="mt-2">
              Weitere Informationen unter:{" "}
              <a href={INVICTAX_URL} target="_blank" rel="noopener noreferrer" className="text-indigo-600">
                {INVICTAX_URL}
              </a>
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-slate-900 mb-3">Haftungsausschluss</h2>
            <p>
              Die Inhalte dieser Plattform wurden mit grösstmöglicher Sorgfalt erstellt. Für die
              Richtigkeit, Vollständigkeit und Aktualität der Inhalte übernehmen wir jedoch keine
              Gewähr. Buchhaltungs- und Steuerinformationen ersetzen keine individuelle Beratung
              durch Treuhand- oder Steuerfachpersonen.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-slate-900 mb-3">Urheberrecht</h2>
            <p>
              Alle Inhalte, Marken und Designs dieser Plattform sind urheberrechtlich geschützt.
              Jede Verwendung ausserhalb der lizenzierten Nutzung bedarf der schriftlichen
              Zustimmung der InvictaX Group GmbH.
            </p>
          </div>
        </section>
      </main>

      <footer className="max-w-3xl mx-auto px-6 pb-10 text-xs text-slate-400">
        © {new Date().getFullYear()} InvictaX Group GmbH ·{" "}
        <Link to="/plattformen" className="hover:text-slate-600">Unsere Plattformen</Link>
      </footer>
    </div>
  );
}
